// components/BigCTASection.js
import React from "react";
import { motion } from "framer-motion";

const fadeIn = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } }
};

const BigCTASection = () => (
  <motion.section
    className="container mx-auto py-14 flex flex-col items-center justify-center"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
    variants={fadeIn}
  >
    <h2 className="text-3xl sm:text-4xl font-extrabold mb-4 text-center text-blue-800 drop-shadow">
      ¿Listo para tener tu propio acuario?
    </h2>
    <p className="text-gray-700 text-lg mb-8 max-w-2xl text-center">
      Descubre la mejor selección de peces, acuarios y kits de inicio. Recibe asesoría personalizada y conviértete en parte del mundo Atlantis.
    </p>
    <a
      href="/tienda"
      className="bg-gradient-to-r from-blue-600 to-cyan-400 text-white px-8 py-4 rounded-2xl font-bold text-xl shadow-lg hover:scale-105 hover:shadow-2xl transition-all"
    >
      Ir a la Tienda
    </a>
  </motion.section>
);

export default BigCTASection;
